// Enterprise-only license-expiry fallback (see backend's
// app/services/license_fallback.py). Rendered in the SAME full-bleed stage
// slot as ContentDisplay (not the small centered state-message slot the
// other state screens — SetupScreen, DeactivatedScreen, etc. — use), since
// this is meant to read as "content" the org deliberately chose to show,
// not a status message. `state.content` stays non-null here (an empty-items
// ContentResponse carrying just this URL), so the App-level dispatch checks
// for it BEFORE the normal showingContent/ContentDisplay branch.
//
// object-contain (not -cover) so the org's uploaded image is never cropped —
// it's a single deliberate image, not a photo/video meant to fill the frame.
export default function LicenseFallbackScreen({ url }: { url: string }) {
  return (
    <div className="w-full h-full bg-black flex items-center justify-center">
      <img src={url} alt="" className="w-full h-full object-contain" />
    </div>
  )
}
